// Trailing debounce: run `fn` once, `ms` after the last call. Used to collapse
// bursts of events (resize, input) into a single trailing invocation.
export const debounce = (fn, ms = 150) => {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn(...args), ms)
  }
}

// Gate for speculative work (image preloading, prefetching): skip when the user
// asked to save data or sits on a slow connection. navigator.connection is
// Chromium-only — Safari/Firefox report nothing and are treated as fast, which
// matches this site's Safari-heavy, mostly-wifi audience.
export const fastConnection = () => {
  const c = navigator.connection
  return !c || (!c.saveData && !/\b[23]g\b/.test(c.effectiveType || ''))
}
